(function () {
  if (window.__dripnordCategoryCardsProgress) {
    window.__dripnordCategoryCardsProgress.init(document);
    return;
  }

  const selector = ".dripnord-category-cards";
  const mobileGridQuery = window.matchMedia("(max-width: 749px)");
  const instances = new WeakMap();

  class CategoryCardsProgress {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector(".dripnord-category-cards__track");
      this.progress = section.querySelector(".dn-category-cards__progress");
      this.fill = section.querySelector(".dn-category-cards__progress-fill");
      this.raf = null;

      if (!this.track || !this.progress || !this.fill) return;

      this.update = this.update.bind(this);
      this.scheduleUpdate = this.scheduleUpdate.bind(this);
      this.track.addEventListener("scroll", this.scheduleUpdate, { passive: true });
      window.addEventListener("resize", this.scheduleUpdate);
      window.addEventListener("orientationchange", this.scheduleUpdate);
      this.update();
    }

    scheduleUpdate() {
      if (this.raf) return;
      this.raf = window.requestAnimationFrame(() => {
        this.raf = null;
        this.update();
      });
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const progressWidth = this.progress.clientWidth;

      if (maxScroll <= 1 || progressWidth <= 0) {
        this.progress.hidden = true;
        return;
      }

      this.progress.hidden = false;

      const visibleRatio = Math.min(this.track.clientWidth / this.track.scrollWidth, 1);
      const scrollRatio = Math.min(Math.max(this.track.scrollLeft / maxScroll, 0), 1);
      const fillWidth = Math.max(progressWidth * visibleRatio, 12);
      const fillTravel = Math.max(progressWidth - fillWidth, 0);

      this.fill.style.width = `${fillWidth}px`;
      this.fill.style.transform = `translateX(${fillTravel * scrollRatio}px)`;
    }

    destroy() {
      if (!this.track) return;
      this.track.removeEventListener("scroll", this.scheduleUpdate);
      window.removeEventListener("resize", this.scheduleUpdate);
      window.removeEventListener("orientationchange", this.scheduleUpdate);

      if (this.raf) {
        window.cancelAnimationFrame(this.raf);
      }
    }
  }

  function init(root) {
    if (mobileGridQuery.matches) return;

    root.querySelectorAll(selector).forEach((section) => {
      if (instances.has(section)) return;
      instances.set(section, new CategoryCardsProgress(section));
    });
  }

  function destroy(root) {
    root.querySelectorAll(selector).forEach((section) => {
      const instance = instances.get(section);
      if (!instance) return;
      instance.destroy();
      instances.delete(section);
    });
  }

  window.__dripnordCategoryCardsProgress = { init, destroy };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
  document.addEventListener("shopify:section:unload", (event) => destroy(event.target));
})();
